import { render, staticRenderFns } from "./AdminLicense.vue?vue&type=template&id=00988b0c&scoped=true&"
import script from "./AdminLicense.vue?vue&type=script&lang=js&"
export * from "./AdminLicense.vue?vue&type=script&lang=js&"
import style0 from "./AdminLicense.vue?vue&type=style&index=0&id=00988b0c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00988b0c",
  null
  
)

export default component.exports